import React from 'react';
import * as Yup from 'yup';
import { FormHandles } from '@unform/core';
import uuid from '../../../../core/components/UniqueHash';
import { useModal } from '../../../../../../hooks/Modal';
import FormComponent, { sanitizeDataObject } from '../../../../core/components/FormComponentUnique';
import { createSchemaByForm, IYup } from '../../../../../../utils/SchemaCreator';
import getValidationErrors from '../../../../../../utils/getValidationErrors';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';
import { useSearch } from '../../../../../../hooks/Search';
import { AxiosInstance } from 'axios';
import { FaPaperPlane, FaPlus, FaUpload } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { urlWebsite } from '../../../../../../config';

interface ICreateModule {
  lineData: Record<string, any>;
  projectHash: string;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

export default function CreateModule({
  lineData, projectHash
}: ICreateModule): JSX.Element {
  const { reloadSearchAll } = useSearch();
  const { addModal, removeModal } = useModal();
  const { addToast } = useToast();

  const key = uuid();

  const sendCampaign = async () => {



    try {
      const project = await api.get('/projects', { params: { where: { url: projectHash } } })





      await api.post(`/mailer-campaign-send/${lineData?._id?.toString()}`, { imagePath: urlWebsite, website: project?.data?.rows?.[0]?.theme_data?.website_url });
      addToast({ title: 'Agendado com sucesso', type: 'success' });
      removeModal('confirm');
      await reloadSearchAll();
    }
    catch (err) {
      addToast({ title: 'Erro ao agendar', type: 'error' })
    }

  }


  const handleCreate = (): void => {
    const content = <>
      <button className='greenButton2' onClick={() => sendCampaign()}>Confirmar envio</button>
    </>;
    if (content) {
      const keyModal = addModal({ title: 'Adicionar contatos', content, key, theme: "whiteModal" });
    }
  };

  const moduleCreate = (): JSX.Element => (
    lineData._id ? <button className="lineIcon" title='Enviar campanha' type="button" onClick={handleCreate}>
      <FaPaperPlane />
    </button> : <></>
  );

  return moduleCreate();
}
